import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  return (
    <footer style={{
      backgroundColor: '#050e09',
      padding: '2rem 2.5rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      flexWrap: 'wrap',
      gap: '1rem',
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: '1.1rem', fontWeight: 800, letterSpacing: '-0.02em' }}>
          <span style={{ color: '#fff' }}>Advokat</span>
          <span style={{ color: '#FFD700' }}>TOP</span>
        </div>
        <small style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.78rem' }}>
          {t('footer.copyright')}
        </small>
      </div>
      <div style={{ display: 'flex', gap: '1.25rem', flexWrap: 'wrap' }}>
        {!user && (
          <Link to="/register?userType=attorney" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.78rem', textDecoration: 'none' }}>
            {t('footer.attorney')}
          </Link>
        )}
        <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.78rem', textDecoration: 'none' }}>
          {t('footer.privacy')}
        </Link>
        <Link to="/terms" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.78rem', textDecoration: 'none' }}>
          {t('footer.terms')}
        </Link>
        <Link to="/delete-account" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.78rem', textDecoration: 'none' }}>
          {t('footer.deleteAccount')}
        </Link>
        <a href="https://t.me/advokattop_managment" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.78rem', textDecoration: 'none' }}>
          {t('footer.supportGroup')}
        </a>
      </div>
    </footer>
  );
};

export default Footer;
